import dotenv from 'dotenv';
import urljoin from 'url-join';
import { createUploadLink } from 'apollo-upload-client';

dotenv.config();

const serverApi = urljoin(
  process.env.REACT_APP_URL || 'https://gql-playground-inventory.herokuapp.com',
  'graphql',
);

const uploadLink = createUploadLink({
  uri: serverApi,
  credentials: 'same-origin',
});

export default uploadLink;
